import { render, staticRenderFns } from "./apiscope.vue?vue&type=template&id=757aca60"
import script from "./apiscope.vue?vue&type=script&lang=js"
export * from "./apiscope.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('757aca60')) {
      api.createRecord('757aca60', component.options)
    } else {
      api.reload('757aca60', component.options)
    }
    module.hot.accept("./apiscope.vue?vue&type=template&id=757aca60", function () {
      api.rerender('757aca60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/authority/apiscope.vue"
export default component.exports